import tituladorautomatico1 from '../tituladorautomatico/tituladorautomatico1.png'

const tituladorautomaticoImagenes = [
    tituladorautomatico1,

]

export default tituladorautomaticoImagenes